import { sanitizeHtml } from '@/utils/formatters';
import { cn } from '@shared';

interface SafeHtmlProps {
  html: string | null | undefined;
  className?: string;
  fallback?: string;
}

/**
 * Renders user-supplied HTML safely via DOMPurify.
 *
 * The server already sanitizes on write (defense in depth — see
 * `task.sanitize.ts`), but the client must sanitize again before
 * `dangerouslySetInnerHTML` so the React tree is safe under any future
 * data source (direct API calls, imports, etc).
 */
export function SafeHtml({ html, className, fallback }: SafeHtmlProps) {
  if (!html) {
    if (fallback) {
      return <p className={cn('text-sm text-muted-foreground', className)}>{fallback}</p>;
    }
    return null;
  }
  return (
    <div
      className={cn('safe-html-content max-w-none min-w-0 break-words', className)}
      style={{ overflowWrap: 'anywhere' }}
      dangerouslySetInnerHTML={{ __html: sanitizeHtml(html) }}
    />
  );
}
